<div style="padding: 0;">
    <router-outlet></router-outlet>
    <app-navbar></app-navbar>
</div>